// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';

import {
  Description,
} from '../../../../../../../components';

import {
  TotalContainer,
  SearchForm,
  ResultVouchersContainer,
  RecentVouchersContainer
} from '../components';

import {
  getText,
  getBookshopTotal,
  getRecentVouchers,
  getRecentLoader,
  getSearchLoader,
  getVouchers,
} from '../store/selectors.js';
import * as vouchersActions from '../store/actions';

import styles from './styles';


class Vouchers extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    text: PropTypes.string,
    recentLoading: PropTypes.bool,
    searchLoading: PropTypes.bool,
    bookshopTotal: PropTypes.object,
    recentVouchers: PropTypes.array,
    vouchers: PropTypes.array,

    getBookshopTotal: PropTypes.func,
    getRecentVouchers: PropTypes.func,
    changeSearchField: PropTypes.func,
    searchVouchers: PropTypes.func,
    clearSearchResult: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    text: null,
    recentLoading: false,
    searchLoading: false,
    bookshopTotal: {},
    recentVouchers: [],
    vouchers: [],

    getBookshopTotal: () => { },
    getRecentVouchers: () => { },
    changeSearchField: () => { },
    searchVouchers: () => { },
    clearSearchResult: () => { },
  };

  componentDidMount() {
    this.props.getBookshopTotal();
    this.props.getRecentVouchers();
  }

  render() {
    const {
      classes,
      text,
      bookshopTotal,
      recentVouchers,
      vouchers,
      recentLoading,
      searchLoading,
      changeSearchField,
      searchVouchers,
      clearSearchResult,
    } = this.props;

    return (
      <div className={classes.root}>
        <MediaQuery maxWidth={549}>
          <Description text={'Vouchers'} />
        </MediaQuery>
        <TotalContainer bookshopTotal={bookshopTotal} />
        <SearchForm
          text={text}
          activateClearButton={vouchers.length !== 0}
          onChange={changeSearchField}
          onSearch={searchVouchers}
          onClear={clearSearchResult}
        />
        <ResultVouchersContainer loading={searchLoading} vouchers={vouchers} />
        <RecentVouchersContainer loading={recentLoading} vouchers={recentVouchers} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    text: getText(state),
    recentLoading: getRecentLoader(state),
    searchLoading: getSearchLoader(state),
    bookshopTotal: getBookshopTotal(state),
    recentVouchers: getRecentVouchers(state),
    vouchers: getVouchers(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBookshopTotal: () => dispatch(vouchersActions.getBookshopTotal()),
    getRecentVouchers: () => dispatch(vouchersActions.getRecentVouchers()),
    changeSearchField: (value, field) => dispatch(vouchersActions.changeSearchField(value, field)),
    searchVouchers: () => dispatch(vouchersActions.searchVouchers()),
    clearSearchResult: () => dispatch(vouchersActions.clearSearchResult()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Vouchers));
